import { gql } from '@apollo/client/core';
import {
  Alcohol,
  Awards,
  AwardsAsText,
  BottleImage,
  BottleSize,
  BottlesPerCase,
  CaseFormat,
  ClosureType,
  Country,
  EanBottle,
  InventoryId,
  PackageBottleSize,
  PressAnecdotes,
  ProductPrice,
} from '.';

/**
 * Creates a query that contains all the attributes required to use Product components
 */
const productFragment = gql`
  fragment Product on RegisteredProduct {
    product {
      ...Alcohol
      ...Awards
      ...AwardsAsText
      ...BottleSize
      ...BottleImage
      ...BottlesPerCase
      ...CaseFormat
      ...ClosureType
      ...Country
      ...EanBottle
      ...InventoryId
      ...PackageBottleSize
      ...PressAnecdotes
    }
    ...ProductPrice
  }
  ${Alcohol.fragment}
  ${Awards.fragment}
  ${AwardsAsText.fragment}
  ${BottleImage.fragment}
  ${BottleSize.fragment}
  ${BottlesPerCase.fragment}
  ${CaseFormat.fragment}
  ${Country.fragment}
  ${ClosureType.fragment}
  ${EanBottle.fragment}
  ${InventoryId.fragment}
  ${PackageBottleSize.fragment}
  ${PressAnecdotes.fragment}
  ${ProductPrice.fragment}
`;

export default productFragment;
